import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';

/**
 * A preloading strategy that only preloads routes explicitly marked with `data: { preload: true }`.
 *
 * Unlike `PreloadAllModules`, this avoids downloading every lazy module immediately after bootstrap.
 * Only high-traffic routes (e.g., shop, checkout) should be marked for preloading.
 *
 * Usage in route definition:
 * ```ts
 * { path: 'lodder-til-salg', loadChildren: () => ..., data: { preload: true } }
 * ```
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route.data?.['preload'] === true ? load() : EMPTY;
  }
}
